import React from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";

import {
  AWARDS,
  AWARDS_BASE_ROUTE,
  PROPOSALS,
  PROPOSALS_BASE_ROUTE,
  SUBAWARDS,
  SUBAWARDS_BASE_ROUTE
} from "globals/constants";

import { subawardSelectors } from "../../store/selectors";
import { TaskListView } from "./List";
import styles from "./styles.css";

export function FormTasksView () {
	const params = useParams();
	const instanceId = params.proposalId ?? params.subawardId ?? params.awardId;
	const { subaward } = useSelector(subawardSelectors.content);
	const linkedAwardId = subaward?.awardId;

	function getTaskPagePath (id, taskType) {
		let formType = id ?? "create";
		let url;
		if (params.subawardId) {
			if (linkedAwardId) {
				url = `/sp${AWARDS_BASE_ROUTE}/${linkedAwardId}/sub-awards/${params.subawardId}/${taskType}/${formType}`;
			} else {
				url = `/sp${SUBAWARDS_BASE_ROUTE}/${params.subawardId}/${taskType}/${formType}`;
			}
		} else if (params.awardId) {
			url = `/sp${AWARDS_BASE_ROUTE}/${params.awardId}/${taskType}/${formType}`;
		} else if (params.proposalId) {
			url = `/sp${PROPOSALS_BASE_ROUTE}/${params.proposalId}/${taskType}/${formType}`;
		}

		return url;
	}

	const taskListType = () => {
		if (params.subawardId) {
			return SUBAWARDS;
		} else if (params.awardId) {
			return AWARDS;
		} else {
			return PROPOSALS;
		}
	};

	return (
		<div id="view-main-task" className={styles.viewMainTask}>
			<TaskListView
				instanceId={instanceId}
				tasksFor={taskListType()}
				getTaskPagePath={getTaskPagePath}
			/>
		</div>
	);
}
